interface CategoryHeroProps {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

const heroBgMap: Record<string, string> = {
  wuxia: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20epic%20scene%20with%20ancient%20Chinese%20style%20warriors%20in%20dynamic%20combat%2C%20flowing%20robes%2C%20dramatic%20golden%20and%20crimson%20color%20scheme%2C%20ink%20wash%20painting%20aesthetic%2C%20motion%20blur%2C%20atmospheric%20lighting&width=1920&height=800&seq=category-hero-wuxia&orientation=landscape",
  fantasy: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20world%20illustration%20with%20magical%20tower%20and%20floating%20islands%2C%20ethereal%20blue%20and%20gold%20light%2C%20mystical%20atmosphere%2C%20dreamy%20celestial%20elements%2C%20webtoon%20style&width=1920&height=800&seq=category-hero-fantasy&orientation=landscape",
  romance: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20scene%20with%20cherry%20blossoms%20in%20spring%2C%20soft%20pink%20and%20warm%20peach%20color%20palette%2C%20couple%20silhouette%20in%20beautiful%20park%2C%20dreamy%20bokeh%20effect%2C%20romantic%20atmosphere&width=1920&height=800&seq=category-hero-romance&orientation=landscape",
  suspense: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20noir%20scene%20in%20rainy%20Seoul%20alley%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20dark%20atmosphere%2C%20suspenseful%20mood%2C%20dramatic%20shadows&width=1920&height=800&seq=category-hero-suspense&orientation=landscape",
  historical: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20palace%20scene%20with%20traditional%20Korean%20architecture%2C%20elegant%20hanbok%20figures%2C%20warm%20golden%20sunset%20light%2C%20regal%20atmosphere%2C%20romantic%20drama%20feel&width=1920&height=800&seq=category-hero-historical&orientation=landscape",
  school: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20scene%20with%20cherry%20blossoms%20and%20modern%20campus%2C%20youthful%20vibrant%20colors%2C%20warm%20sunlight%2C%20friends%20gathering%2C%20energetic%20atmosphere&width=1920&height=800&seq=category-hero-school&orientation=landscape",
};

export default function CategoryHero({ name, slug, icon, description }: CategoryHeroProps) {
  const bgUrl = heroBgMap[slug] || heroBgMap.fantasy;

  return (
    <section className="relative w-full h-[320px] md:h-[420px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={bgUrl}
          alt={`${name}漫画 - 韩漫网高清韩国漫画`}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-white/15 backdrop-blur-sm mx-auto mb-4">
          <i className={`${icon} text-2xl text-white`}></i>
        </div>
        <h1 className="text-2xl md:text-4xl font-black text-white mb-2"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {name}漫画
        </h1>
        <p className="text-sm md:text-base italic text-white/80 mb-1 md:mb-2"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          精选高清{name}韩漫
        </p>
        <p className="text-xs md:text-sm text-white/60 max-w-md mx-auto">
          {description}
        </p>
      </div>
    </section>
  );
}